import React from "react";

export const ChatswoodBuildings = () => {
  return (
    <iframe
      src="https://dokooy1qg41br.cloudfront.net/index.html"
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
      }}
      title="Chatswood Buildings Demo"
    />
  );
};